/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelPraticaNotaDTO } from '../model/models';
import { PraticaNotaCreateRequest } from '../model/models';
import { PraticaNotaDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreatePraticaNotaRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaNotaCreateRequest: PraticaNotaCreateRequest;
}

export interface DeletePraticaNotaRequestParams {
    idTipoPratica: string;
    idPratica: string;
    idNota: string;
}

export interface ListPraticaNoteRequestParams {
    idTipoPratica: string;
    idPratica: string;
    pageable: Pageable;
}


export interface GestioneNotePraticaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea una nuova nota operatore sulla pratica. Emette in stessa TX l\&#39;evento NOTA_OPERATORE_AGGIUNTA. Capability GESTIONE richiesta.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/note
* @param requestParameters
     */
    createPraticaNota(requestParameters: CreatePraticaNotaRequestParams, extraHttpRequestParams?: any): Observable<PraticaNotaDTO>;

    /**
     * Cancellazione LOGICA di una nota operatore della pratica (D-109). Non e\&#39; una DELETE fisica: setta cancellataAt/cancellataDaUser ed emette NOTA_OPERATORE_CANCELLATA nella stessa TX. Una nota gia\&#39; cancellata risponde 422. Capability GESTIONE richiesta.
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/note/{idNota}
* @param requestParameters
     */
    deletePraticaNota(requestParameters: DeletePraticaNotaRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Lista paginata delle note della pratica. Sort default created_at DESC, customizzabile via ?sort&#x3D;. Esclude le note cancellate logicamente (visibili solo a SUPERADMIN). Capability CONSULTAZIONE.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/note
* @param requestParameters
     */
    listPraticaNote(requestParameters: ListPraticaNoteRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaNotaDTO>;

}
